<script>
export default {};
</script>
<template>
  <div class="modal">
    <slot />
  </div>
</template>
<style lang="scss">
.modal {
  position: fixed;
  left: 12.5%;
  right: 12.5%;
  top: 12.5%;
  bottom: 12.5%;
  height: 75vh;
  width: 75vw;
  z-index: 1;
  border: 3px solid aquamarine;
  padding: 15px;
  background-color: #3d546df0;
}
</style>
